var _Object$setPrototypeOf = require("@babel/runtime-corejs2/core-js/object/set-prototype-of");

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = _Object$setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime-corejs2/helpers/setPrototypeOf.js
 ** module id = 622
 ** module chunks = 0
 **/